import {Observable} from 'rxjs';
import {ItemDocDependency, PriorityPatchRequest} from '@primatoo-ms-organization';
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";

import {HttpClient} from '@angular/common/http';
import {ImportDataService} from './import-data-service';
import {DeleteEntityServiceInterface} from "./delete-entity-service-interface";
import {UpsertUserColumnRequest} from "it/primatoo/openapi/api/org/schemas/common/UpsertUserColumnRequest";

/**
 * Interfaccia comune a tutti i data protection governance....
 * Sostituire nell'implementazione any con lo specifico DTO
 */
export abstract class DataProtectionGovernanceService extends ImportDataService implements DeleteEntityServiceInterface {

  protected constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  abstract setPriority(id: number, request: PriorityPatchRequest): Observable<any>;

  abstract getEndPointV1(): string;


  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.getEndPointV1() + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public updateUserColumns(i: UpsertUserColumnRequest): Observable<void> {
    const url = this.getEndPointV1() + 'user-columns';
    const request = {
      config: i.columns
    }
    return this.httpClient.post<void>(url, request);
  }


  public delete(id: number): Observable<void> {
    const url = this.getEndPointV1() + `${id}/`;
    return this.httpClient.delete<void>(url);
  }

  public deleteMultiple(ids: number[]): Observable<{ failed: number[] }> {
    // const url = this.getEndPoint() + `by-ids`;
    // return this.httpClient.request<{ failed: number[] }>('DELETE', url, {body: {ids}})

    const url = this.getEndPointV1() + `by-ids`;
    return this.httpClient.post<{ failed: number[] }>(url, {ids})
  }

  public getDocDependencies(id: number): Observable<ItemDocDependency[]> {
    const url = this.getEndPointV1() + `${id}/doc-dependencies/`;
    return this.httpClient.get<ItemDocDependency[]>(url);
  }

}
